export const COLORS = {
  black: '#000000',
  white: '#FFFFFF',
  gray: '#D3D3B3',
  red: '#FC5C63',
  blue: '#5fbbe3',
};
